import { useLazyQuery, useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router';
import { getAdminClient } from '../AdminApolloClient';
import { CONTENT_EDIT_ITEM } from '../../../../../client/__graphql__/queries/page_content/getEditItem';
import { PageContentType } from '../../../../../server/global/enum';
import { H1, H2 } from '../../HeaderTitle';
import { EditorForm } from './EditorForm';
import { EditorImages } from './EditorImages';


const client = getAdminClient();
enum EditorType { Text, Images }

export const PageContainer = (props: { content_type: PageContentType }) => {
    const params = useParams<{ kontor: string; type: string }>();
    const [content_type, SetContentType] = useState(props.content_type);
    const [editorType, setEditorType] = useState(EditorType.Text);
    const [bkpcontent, SetBackUpContent] = useState(null);
    const [is_loading, SetIsLoading] = useState(true);

    const [getPageContent, { data, error, loading }] = useLazyQuery(CONTENT_EDIT_ITEM,
        { fetchPolicy: 'network-only', client: client }
    );

    useEffect(() => {
        if (data && data?.getNdPageEditItem) {
            SetIsLoading(false);
        }
    }, [data]);

    const getContent = () => {
        SetIsLoading(true);
        getPageContent({
            variables: {
                input: {
                    urltag: params.kontor,
                    type: content_type,
                },
            },
        });
    };

    const GoToText = () => {
        setEditorType(EditorType.Text);
    }

    const GoToImagesBackup = (content: any) => {
        if (content != null) {
            SetBackUpContent(content);
        }
        setEditorType(EditorType.Images);
    }

    const GoToImages = () => {
        setEditorType(EditorType.Images);
    }

    useEffect(() => {
        getContent();
    }, [params.kontor]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [editorType]);

    //data && data.getNdPageEditItem
    if (!is_loading) {
        const content = data?.getNdPageEditItem;

        if (editorType == EditorType.Images) {
            return (<EditorImages urltag={params.kontor} content_type={content.type_data} OnGoToText={GoToText} />);
        }
        else {
            return (<EditorForm page_content={content} urltag={params.kontor} OnGoToImages={GoToImagesBackup} backup={bkpcontent} />);
        }
    }

    return (<>
        <LoadDiv>
            <h2>Loading...</h2>
        </LoadDiv>
    </>);
}

const LoadDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export default PageContainer;